import styled from '@emotion/styled';
import { IconName } from '@shared/components/core/images/IconMap';
import Icons, { IIconsProps } from '@shared/components/core/images/Icons';
import { Tag } from '@shared/components/core/text/ContentTypography';
import { BodySmall, TitleSmall } from '@shared/components/core/text/Typography';
import { ICoreCardProps } from '@shared/models/components/ICoreCardProps';
import { CardStackWrap, WrapCardText } from './CommonCardStyles';

interface ICardStackProps extends Omit<IIconsProps, 'name'>, ICoreCardProps {
    id?: string;
    name?: IconName;
    statusText?: string;
    tagNode?: React.ReactNode;
}

const CardStack: React.FC<ICardStackProps> = ({
    id,
    title,
    description,
    name,
    size = 50,
    statusText: tag,
    tagNode,
    children,
    ...restProps
}) => {
    return (
        <CardStackWrap id={id}>
            {name && <Icons name={name} size={size} {...restProps} />}
            <StackWrapCardText>
                {tag && <CustomTag>{tag}</CustomTag>}
                {tagNode ? (
                    <CustomTagNode>
                        {tagNode} <TitleSmall>{title}</TitleSmall>
                    </CustomTagNode>
                ) : (
                    <TitleSmall>{title}</TitleSmall>
                )}
                <BodySmall>{description}</BodySmall>
                {children}
            </StackWrapCardText>
        </CardStackWrap>
    );
};

// TODO: Did not want to change this because this at the time (Release)
// Should replace this with import of shared tag component: InlineTagNodeWrap
const CustomTagNode = styled.div`
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
`;

const CustomTag = styled(Tag)`
    margin: 0;
`;

const StackWrapCardText = styled(WrapCardText)`
    padding: 0 1.25rem 1.25rem 1.25rem;
`;

export default CardStack;
